import { formatDate } from '@/common/js/utils'

export default {
  methods: {
    adResource(cellValue) {
      const ucResFn = (val) => {
        if (val === '1') return '落地页'
        else if (val === '2') return 'iOS应用'
        else return '未知'
      }
      const tenResFn = (val) => {
        if (val === 'PROMOTED_OBJECT_TYPE_APP_ANDROID') return '安卓应用'
        else if (val === 'PROMOTED_OBJECT_TYPE_APP_IOS') return 'iOS应用'
        else if (val === 'PROMOTED_OBJECT_TYPE_APP_ANDROID_UNION') return '安卓联盟'
        else return val
      }
      const bdResFn = (val) => {
        if (val === 1) return '网站链接'
        else if (val === 2) return 'iOS应用'
        else if (val === '[]') return '不限'
        else if (val === '[1]') return '列表页'
        else if (val === '[2]') return '详情页'
        else if (val === '[1,2]') return '列表页,详情页'
        else return '未知'
      }
      if (this.media === 6) return ucResFn(cellValue)
      else if (this.media === 16) return tenResFn(cellValue)
      else if (this.media === 45) return bdResFn(cellValue)
    },
    adConvertType(cellValue) {
      const ucResFn = (val) => {
        if (val === 1) return '激活'
        else if (val === 2) return '下载'
        else if (val === 0) return '-'
        else return '未知'
      }
      const bdResFn = (val) => {
        if (val === 1) return '激活'
        else if (val === 0) return '-'
        else return '未知'
      }
      if (this.media === 6) return ucResFn(cellValue)
      if (this.media === 45) return bdResFn(cellValue)
    }
  },
  filters: {
    adStatus: (cellValue) => {
      let state
      switch (cellValue) {
        case 1:
          state = '投放中'
          break
        case 2:
          state = '暂停'
          break
        case 3:
          state = '审核中'
          break
        case 4:
          state = '审核不通过'
          break
        case 5:
          state = '账户余额不足'
          break
        case 6:
          state = '计划预算不足'
          break
        case 7:
          state = '未到投放时间'
          break
        case 8:
          state = '计划组暂停'
          break
        case 9:
          state = '准备中'
          break
        case 10:
          state = '冻结'
          break
        case 11:
          state = '投放结束'
          break
        case 12:
          state = '计划组预算不足'
          break
        case 13:
          state = '账户日预算不足'
          break
        default:
          state = '未知'
          break
      }
      return state
    },
    adTouTime: (cellValue, row) => {
      let timer
      const start = formatDate(new Date(row.adStartTime), 'yyyy-MM-dd')
      const end = formatDate(new Date(row.adEndTime), 'yyyy-MM-dd')
      if (row.adStartTime && row.adEndTime && !String(start).includes('1970') && !String(end).includes('1970')) timer = `${start} — ${end}`
      else timer = '不限'
      return timer
    }
  }
}
